export function formatarData(data) {
  if (!data) return "";
  const date = new Date(data);
  if (isNaN(date.getTime())) return "";
  const dia = String(date.getUTCDate()).padStart(2, "0");
  const mes = String(date.getUTCMonth() + 1).padStart(2, "0");
  const ano = date.getUTCFullYear();
  return `${dia}/${mes}/${ano}`;
}

export function getDataHoraLocal() {
  const agora = new Date();
  const offset = agora.getTimezoneOffset() * 60000; // offset do navegador em ms
  const dataLocal = new Date(agora.getTime() - offset);
  return dataLocal.toISOString().slice(0, 16);
}

export function formatarDataHora(dataHora) {
  if (!dataHora) return "";
  const data = new Date(dataHora);
  if (isNaN(data.getTime())) return "";

  const dia = String(data.getDate()).padStart(2, "0");
  const mes = String(data.getMonth() + 1).padStart(2, "0"); // Mês é base 0, então somamos 1.
  const ano = data.getFullYear();
  const horas = String(data.getHours()).padStart(2, "0");
  const minutos = String(data.getMinutes()).padStart(2, "0");

  // 4. Monta e retorna a string no formato final.
  return `${dia}/${mes}/${ano} ${horas}:${minutos}`;
}
export function getLocalDateTime(data, formato = "ISO") {
  const now = new Date(data);

  const year = now.getFullYear();
  const month = String(now.getMonth() + 1).padStart(2, "0");
  const day = String(now.getDate()).padStart(2, "0");
  const hours = String(now.getHours()).padStart(2, "0");
  const minutes = String(now.getMinutes()).padStart(2, "0");
  const seconds = String(now.getSeconds()).padStart(2, "0");

  if (formato === "BR") {
    return `${day}-${month}-${year}T${hours}:${minutes}:${seconds}`;
  }

  // Formato ISO: yyyy-MM-ddTHH:mm:ss
  return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}`;
}

export function formatarEnum(palavra) {
  if (!palavra || typeof palavra !== "string") {
    console.warn("⚠️ Valor inválido passado para formatarEnum:", palavra);
    return "";
  }
  return palavra
    .toLowerCase()
    .replace(/_/g, " ")
    .replace(/(^\w|\s\w)/g, (letra) => letra.toUpperCase());
}
export function limitarTexto(texto, maxChar) {
  if (!texto || typeof texto !== "string") {
    return "";
  }
  if (texto.length > maxChar) {
    let newText = texto.slice(0, maxChar);
    newText += "...";
    return newText;
  }
  return texto;
}

export function formatarNomeUsuario(nomeUsuario) {
  if (!nomeUsuario || typeof nomeUsuario !== "string") {
    return "";
  }
  const nome = nomeUsuario.trim().split(" ");
  return nome[0] + (nome.length > 1 ? " " + nome[nome.length - 1] : "");
}

export function formatarCPF(cpf) {
  const apenasNumeros = cpf.replace(/\D/g, "");

  return apenasNumeros.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4");
}

export function formatarCPFMascarado(cpf) {
  if (!cpf) return "";
  const cpfStr = String(cpf).trim();
  if (cpfStr.includes("*")) {
    return cpfStr;
  }
  let apenasNumeros = cpfStr.replace(/\D/g, "");
  if (apenasNumeros.length === 0) {
    return cpfStr;
  }
  if (apenasNumeros.length < 11) {
    apenasNumeros = apenasNumeros.padStart(11, "0");
  }
  if (apenasNumeros.length !== 11) {
    return cpfStr;
  }
  const parte1 = apenasNumeros.slice(0, 3);
  const parte2 = apenasNumeros.slice(9, 11);
  return `${parte1}.***.***-${parte2}`;
}

export function formatarParaInputDateTimeLocal(dataStr) {
  if (!dataStr) return "";
  const date = new Date(dataStr);
  if (isNaN(date.getTime())) return "";
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  const hours = String(date.getHours()).padStart(2, "0");
  const minutes = String(date.getMinutes()).padStart(2, "0");
  return `${year}-${month}-${day}T${hours}:${minutes}`;
}

export function sanitizarSql(texto) {
  if (!texto || typeof texto !== "string") return "";
  // Remove caracteres potencialmente perigosos para SQL Injection (ex: ', ", \, ;, --, /*, */)
  return texto.replace(/['"\\;]|\-\-|\/\*|\*\//g, "");
}

export function extrairTextoHtml(html) {
  if (!html || typeof html !== "string") return "";

  // Adiciona espaçamento entre tags de bloco para evitar palavras coladas (ex: <p>Olá</p><p>Mundo</p> -> Olá Mundo)
  const htmlComEspacos = html
    .replace(/<\/(p|div|li|h[1-6]|tr|td|th)>/gi, " ")
    .replace(/<br\s*\/?>/gi, " ");

  if (typeof window !== "undefined" && typeof DOMParser !== "undefined") {
    try {
      const doc = new DOMParser().parseFromString(htmlComEspacos, "text/html");
      return (doc.body.textContent || doc.body.innerText || "")
        .replace(/\s+/g, " ")
        .trim();
    } catch (e) {
      // Fallback para regex
    }
  }

  return htmlComEspacos
    .replace(/<style[^>]*>[\s\S]*?<\/style>/gi, "")
    .replace(/<script[^>]*>[\s\S]*?<\/script>/gi, "")
    .replace(/<[^>]+>/g, "")
    .replace(/&nbsp;/g, " ")
    .replace(/&amp;/g, "&")
    .replace(/&lt;/g, "<")
    .replace(/&gt;/g, ">")
    .replace(/&quot;/g, '"')
    .replace(/&#39;/g, "'")
    .replace(/\s+/g, " ")
    .trim();
}

export function criarMensagemErro(erro) {
  if (typeof erro === "string") return erro;
  const dadosErro = erro?.response?.data || erro?.data;
  if (dadosErro) {
    if (typeof dadosErro === "string") return "\n" + dadosErro;
    if (Array.isArray(dadosErro.errors) && dadosErro.errors.length > 0) {
      const mensagens = dadosErro.errors.map((e) => e.message || e.defaultMessage || e);
      return "\n" + mensagens.join(", ");
    }
    if (dadosErro.message) {
      return "\n" + dadosErro.message;
    }
  }
  return (
    "\n" + "Ocorreu um erro inesperado. Por favor, tente novamente mais tarde."
  );
}

export async function carregarImagemUrlComoBase64(url) {
  if (!url) return { mimeType: "", base64Data: "", descricaoImagem: "" };
  try {
    const response = await fetch(url);
    const blob = await response.blob();
    const tiposPermitidos = ["image/jpeg", "image/png"];
    if (!tiposPermitidos.includes(blob.type)) {
      return { mimeType: "", base64Data: "", descricaoImagem: "" };
    }
    const base64Data = await new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = () => resolve(reader.result.split(",")[1]);
      reader.onerror = reject;
      reader.readAsDataURL(blob);
    });
    return { mimeType: blob.type, base64Data, descricaoImagem: "" };
  } catch (error) {
    console.warn("Erro ao processar imagem existente:", error);
    return { mimeType: "", base64Data: "", descricaoImagem: "" };
  }
}

export const removerHtml = extrairTextoHtml;
export const stripHtml = extrairTextoHtml;
